import React, { useCallback, useEffect, useMemo } from 'react';
import { Card } from 'tea-component';
import { useLocation } from "umi";
import FilterBase from '@/pages/dashboard/components/NewFilter/FilterBase';
import { isEmpty } from 'lodash-es';
import { getDefaultValueFromUrl, getDefaultValue, getUrlParams } from './utils';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { IFilterProps, IFilterValueType, IInputItemType } from './_type';

import './index.scss';
import '@/pages/dashboard/components/Filter/index.scss';

// 筛选器组件每进入一个页面，重新初始化一次，避免冲突
const Filter = (props: IFilterProps) => {
  const {
    // 筛选器外部loading,筛选器会在外部loading结束后执行初始化 init
    loading,
    onInit,
    value,
    inputList,
    onConfirm: propsOnConfirm,
    onReset: propsOnReset,
    onChange: propsOnChange,
    error,
    loadingHeight = 92,
    children, // 子组件
    // 自定义组件
    extraRenderContent,
    ...restProps
  } = props;

  // 如果是外部数据源，则取数据源中的最新时间
  const location = useLocation();

  // 筛选器默认值
  const defaultValue = useMemo(() => {
    const obj: IFilterValueType = {};
    inputList?.forEach((item: IInputItemType) => {
      obj[item.key] = item?.default;
    });
    return obj;
  }, [inputList]);

  // 筛选器初始化，触发init
  useEffect(() => {
    if (!loading && onInit) {
      // isInitRef.current = false;
      const filterUrlParams: any = getUrlParams(location?.query, inputList); // todo query ts报错
      let value: any = {};
      const urlIsNotEmpty = !isEmpty(filterUrlParams);
      // 优先级： url>默认
      if (urlIsNotEmpty) {
        value = getDefaultValueFromUrl(inputList, filterUrlParams, defaultValue);
      } else {
        value = getDefaultValue(inputList, defaultValue);
      };
      onInit({ ...value });
    }
  }, [loading]);

  // confirm 事件
  const onConfirm = useCallback((value: any): void => {
    propsOnConfirm?.(value);
  }, [propsOnConfirm]);

  // reset 事件
  const onReset = useCallback((value: any): void => {
    propsOnReset?.(value);
  }, [propsOnReset]);
  // onChange 事件
  const onChange = (key: any, val: any): void => {
    propsOnChange?.(key, val);
  };

  return <>
    <div className="dbb-filter-container">
      <Card>
        <Card.Body>
          <Abnormal
            isLoading={false}
            isError={error}
            componentLoading={loading}
            style={{ height: loadingHeight }}
            advanceRender={false}
            component={(
              <>
                <FilterBase
                  className="dbb-filter-content-wrap"
                  showBubble={false}
                  {...restProps}
                  value={value}
                  defaultValue={defaultValue}
                  inputList={inputList}
                  onConfirm={onConfirm}
                  onReset={onReset}
                  onChange={onChange}
                  extraSlot={
                    <>
                      {
                        extraRenderContent && React.Children.map(extraRenderContent, child => {
                          if (React.isValidElement(child)) {
                            return React.cloneElement(child, {});
                          }
                          // todo 是否返回一个默认元素
                          return null;
                        })}
                    </>
                  }
                />
              </>
            )}
          />
        </Card.Body>
      </Card>
    </div>
    {
      children
    }
  </>;
};

export default Filter;
